import React from 'react';
import PropTypes from 'prop-types';
import { useDataModel } from '@thd-nucleus/data-sources';
import { emtContentDataModel } from '../dataModels';
import { PAGE_NAMES } from '../../constants';
import RentalCompactGrid from './RentalCompactGrid';

const LargeEquipmentRentalsCards = ({ contentId }) => {
  const { data, loading, error } = useDataModel('emtContent', {
    variables: { contentId, pageName: PAGE_NAMES.RENTALS },
    skip: !contentId,
  });
  const { title, rentalItems } = data?.emtContent?.content?.rentalsInformationv2?.largeEquipmentRentals || {};
  return <RentalCompactGrid title={title} rentalItems={rentalItems} loading={loading} error={error} />;
};

LargeEquipmentRentalsCards.displayName = 'LargeEquipmentRentalsCards';
LargeEquipmentRentalsCards.propTypes = { contentId: PropTypes.string.isRequired };
LargeEquipmentRentalsCards.dataModel = emtContentDataModel;

export default LargeEquipmentRentalsCards;